var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconBell = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 13,
  height: 17,
  viewBox: "0 0 13 17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1",
  clipPath: "url(#clip0_8_2635)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Bell"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M11.4683 13.2184C11.0558 13.2184 10.7183 12.8584 10.7183 12.4184V6.0184C10.7183 3.8104 9.03826 2.0184 6.96826 2.0184C4.89826 2.0184 3.21826 3.8104 3.21826 6.0184V12.4184C3.21826 12.8584 2.88076 13.2184 2.46826 13.2184C2.05576 13.2184 1.71826 12.8584 1.71826 12.4184V6.0184C1.71826 2.9304 4.07326 0.418396 6.96826 0.418396C9.86326 0.418396 12.2183 2.9304 12.2183 6.0184V12.4184C12.2183 12.8584 11.8808 13.2184 11.4683 13.2184Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M6.96826 16.4184C5.73076 16.4184 4.71826 15.3384 4.71826 14.0184C4.71826 12.6984 5.73076 11.6184 6.96826 11.6184C8.20576 11.6184 9.21826 12.6984 9.21826 14.0184C9.21826 15.3384 8.20576 16.4184 6.96826 16.4184ZM6.96826 13.2184C6.55576 13.2184 6.21826 13.5784 6.21826 14.0184C6.21826 14.4584 6.55576 14.8184 6.96826 14.8184C7.38076 14.8184 7.71826 14.4584 7.71826 14.0184C7.71826 13.5784 7.38076 13.2184 6.96826 13.2184Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M12.2183 13.2184H1.71826C1.30576 13.2184 0.968262 12.8584 0.968262 12.4184C0.968262 11.9784 1.30576 11.6184 1.71826 11.6184H12.2183C12.6308 11.6184 12.9683 11.9784 12.9683 12.4184C12.9683 12.8584 12.6308 13.2184 12.2183 13.2184Z"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_8_2635"
}, /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 16,
  fill: "white",
  transform: "translate(0.968262 0.418396)"
})))));
export default SvgIconBell;